const funcs = {};

export const register = (key, func) => {
  funcs[key] = func;
};

export const call = (key, ...args) => {
  const func = funcs[key];

  if (!func) {
    console.error(`Function not found: ${key}`);
    return;
  }

  return func(...args);
};

export const remove = (key) => {
  delete funcs[key];
};

export const has = (key) => Object.prototype.hasOwnProperty.call(funcs, key);
